import {MouseEventHandler} from "react"

type Props = {
    onClick: MouseEventHandler
}
export default function CategoryUpdateButton({onClick}: Props) {
    return (
        <button className="button is-small is-rounded is-info is-outlined ml-1" onClick={onClick}>수정</button>
    )
}